<template>
  <div class="schedule">
  <emptyModule>
    <div class="bar">
      <span> </span>
      <span> </span>
    </div>
    <template v-if="scheduleData && !isOut">
      <router-link
        v-if="isCanDrawType &&  isCurrentDrawDate && !isMoreSchedule"
        class="look-more-link"
        to="/winterGame/moreSchedule"
        >查看全部></router-link
      >
      <div v-if="!isMoreSchedule" :class="['game-type-title', {'game-type-title-draw': drawStatus !== -1 && isCurrentDrawDate}]">
        <img src="../../../assets/images/squirrelCup/2023/summer/yh.png" />
        <template v-if="gameType === 1">全网大乱斗</template>
        <template v-if="gameType === 2">精英争霸赛</template>
        <template v-if="gameType === 3">全国大赛小组赛</template>
        <template v-if="gameType === 4">{{ scheduleData.section_name }}</template>
        <template v-if="gameType === 5">巅峰赛</template>
        <template v-if="gameType === 6">竞技场大乱斗</template>
        <template v-if="gameType === 7">战队联赛</template>
        <template v-if="gameType === 8">热身赛</template>
        <template v-if="gameType === 9">竞技场争霸赛</template>
        <img src="../../../assets/images/squirrelCup/2023/summer/yh2.png" />
      </div>
      <template
        v-if="shouldShowStandardGame && !isCurrentDrawDate"
      > 
        <header class="header">
          <!-- //TODO 标志比赛状态的组件!!! 二期和一期的 status 字段标志量意思不一样，要根据game_status分别判断 -->
          <pentagon :status="scheduleData.game_status"/>
          <h3 v-if="gameType === 4">
            {{ formattedDate }}
          </h3>
          <h3 v-else>{{ scheduleData.section_name }}</h3>
          <router-link
            v-if="isShowMore && !isCurrentDrawDate"
            class="more"
            to="/winterGame/moreSchedule"
            >查看全部></router-link
          >
          <!-- 占位用的 -->
          <a v-else class="more"></a>
        </header>
        <section
          :class="[
            'winStatus_' +
              (scheduleData.team_id_b === padTeamId
                ? scheduleData.status_b
                : scheduleData.status_a),
            scheduleData.team_id_b === padTeamId ? 'rowReverse' : '',
          ]"
          class="section"
          :style="isNationalGameType ? 'margin-top:10px' : ''"
        >
          <div
            class="notional-game-type"
            v-if="isNationalGameType && false"
          >
            <div>{{ scheduleData.sub_title }}</div>
          </div>
          <!-- 未开始和已取消的时候不显示 -->
          <!-- 巅峰赛有奖杯  &&
              gameType !== 5-->
          <div v-if="
              scheduleData.game_status !== 0 &&
              scheduleData.game_status !== 3 &&
              !isEliteGameType && !isCurrentDrawDate && !isMoreSchedule && gameType !== 4
            " class="war-zone-name group_name">
            <p class="war-zone-name-text">{{ scheduleData.group_name }}</p>
          </div>
          <div
            v-if="
              scheduleData.game_status !== 0 &&
              scheduleData.game_status !== 3 &&
              !isEliteGameType && !isCurrentDrawDate
            "
            class="summer-jb"
          >
            <span
              ><img src="../../../assets/images/winterGame/jb.png" />
              {{ scheduleData.score_a | formatNumberFilter }}</span
            >
            <span></span>
            <span
              ><img src="../../../assets/images/winterGame/jb.png" />{{
                scheduleData.score_b | formatNumberFilter
              }}</span
            >
          </div>
          <div class="vs-member">
            <label>{{ scheduleData.team_name_a }}</label>
            <span>VS</span>
            <label>{{ scheduleData.team_name_b }}</label>
          </div>
          <div
            v-if="scheduleData.game_status !== 1"
            class="spring-jb"
          >
            <span
              ><img src="../../../assets/images/winterGame/jb.png" />×{{
                scheduleData.score_a | formatNumberFilter
              }}</span
            >
            <span></span>
            <span
              ><img src="../../../assets/images/winterGame/jb.png" />×{{
                scheduleData.score_b | formatNumberFilter
              }}</span
            >
          </div>
          <div v-else></div>
        </section>
      </template>
      <!-- 1/6是大乱斗和竞技场，2024冬季赛逻辑更新，字段增加 -->
      <template v-if="isHotGameType && newSeason && !isCurrentDrawDate">
        <header class="header2">
          <a class="more"></a>
          <span class="next-game-date hot-game-item" v-if="shouldShowNextGameDate">下个比赛日</span>
          <h3 v-if="isHotGameStarted">
            {{ scheduleData.section_name }}
          </h3>
          <router-link
            v-if="isShowMore && isHotGameType"
            class="more"
            to="/winterGame/moreSchedule"
            >查看全部></router-link
          >
          <!-- 占位用的 -->
          <a v-else class="more"></a>
        </header>
        <!-- 不展示查看全部 -->
        <!-- isMoreSchedule表示的是全部战队赛程传过来的数据 -->
        <div class="war-zone-name" v-if="isCanDrawType && !isDrawed && scheduleData.war_zone && !isCurrentDrawDate">
          <p class="war-zone-name-text">{{ scheduleData.war_zone }}</p>
        </div>
        <div class="war-zone-name" v-if="scheduleData.war_zone && !isCurrentDrawDate && drawStatus == 3">
          <p class="war-zone-name-text">{{ scheduleData.war_zone }}</p>
        </div>
        <section class="section-hot-game" v-if="isHotGameStarted">
          <div>
            <div class="wapper" v-if="shouldShowData">
              <p class="data-num">{{ isMoreSchedule ? scheduleData.daily_score_team_a : scheduleData.sched_daily_score | formatNumberFilter }}</p>
              <p class="describe">今日奖杯数</p>
            </div>
          </div>
          <div>
            <div class="wapper wapper2" v-if="shouldShowData">
              <p class="data-num" v-if="(isMoreSchedule && scheduleData.daily_ware_zone_rank_team_a) || (!isMoreSchedule && scheduleData.sched_daily_rank)">
                {{ (isMoreSchedule ? scheduleData.daily_ware_zone_rank_team_a : scheduleData.sched_daily_rank) | formatNumberFilter }}
                <span
                  class="status"
                  v-if="scheduleData.advancement == 2 && !isArenaGameType && false"
                >
                  未晋级
                </span>
                <span 
                  class="topIcon" 
                  v-if="(scheduleData.sched_daily_half_rank || scheduleData.daily_half_rank) && false">
                  <img src="../../../assets/images/winterGame/topIcon.png" />
                </span>
              </p>
              <p class="describe" v-if="(isMoreSchedule && scheduleData.daily_ware_zone_rank_team_a) || (!isMoreSchedule && scheduleData.sched_daily_rank)">今日排名</p>
              <p class="describe no-rank" v-else-if="(isMoreSchedule && !scheduleData.daily_ware_zone_rank_team_a) || (!isMoreSchedule && !scheduleData.sched_daily_rank)">暂无排名</p>
            </div>
          </div>
        </section>
        <section class="section3" v-if="shouldShowNextGameDate">
          <div class="only-section-name">{{ scheduleData.section_name }}</div>
        </section>
      </template>
      <template v-if="(gameType === 1 || gameType == 6 || gameType == 9) && !newSeason">
        <header class="header2 11">
          <a class="more"></a>
          <h3>
            {{ scheduleData.section_name }}
          </h3>
          <router-link
            v-if="isShowMore && isArenaGameType"
            class="more"
            to="/winterGame/moreSchedule"
            >查看全部></router-link
          >
          <!-- 占位用的 -->
          <a v-else class="more"></a>
        </header>
        <!-- 不展示查看全部 -->
        <section class="section2">
          <div>
            <div class="wapper wapper2">
              <!-- 竞技场没有晋级与否，schedule这里的排名是统一叫做 rank_a，不区分的 -->
              <p class="data-num">
                {{ scheduleData.rank_a | formatNumberFilter }}
                <span
                  class="status"
                  v-if="scheduleData.advancement == 2 && !isArenaGameType"
                >
                  未晋级
                </span>
              </p>
              <p class="describe">全网排名</p>
            </div>
          </div>
          <div>
            <div
              class="wapper"
              v-if="
                scheduleData.today_new_score_a &&
                scheduleData.today_new_score_a !== 0 &&
                !isMoreSchedule
              "
            >
              <p class="data-num">{{ scheduleData.today_new_score_a | formatNumberFilter }}</p>
              <p class="describe">今日新增奖杯数</p>
            </div>
            <div class="wapper">
              <p class="data-num">{{ scheduleData.score_a | formatNumberFilter }}</p>
              <p class="describe">累计奖杯数</p>
            </div>
          </div>
        </section>
      </template>
      <template v-if="isCanDrawType && isCurrentDrawDate">
        <!--是否展示抽签-->
        <div class="draw-wrap" v-if="drawStatus === 0">
          <div class="draw-wrap-content">
            <div class="draw-title">战区抽签进行中</div>
            <div class="draw-time">{{ drawEndTime }}</div>
          </div>
          <div class="draw-btn" @click="goDrawLots">
            立即去抽签
          </div>
        </div>
        <div class="draw-wrap" v-else-if="drawStatus === 1">
          <div class="draw-wrap-content">
            <div class="draw-title draw-result" :class="{'draw-result-no-name': !agentGroupTeamBy.createByName}">{{ agentGroupTeamBy.drawGroupName }}</div>
            <div v-if="agentGroupTeamBy.createByName" class="draw-info">
              <span>抽签人：{{ agentGroupTeamBy.createByName }}</span>
              <span>抽签时间：{{ agentGroupTeamBy.drawTime }}</span>
            </div>
          </div>
          <div class="draw-btn" @click="toDrawResult">
            查看分区情况
          </div>
        </div>
        <div class="draw-wrap" v-else-if="drawStatus === 2">
          <div class="draw-wrap-content">
            <div class="draw-title">战区抽签已结束</div>
            <div class="draw-time">{{ drawEndTime }}</div>
          </div>
          <p class="draw-end-text">抽签已截止，系统自动分组进行中</p>
        </div>
      </template>
    </template>
    <template v-if="!scheduleData && !isOut">
      <section class="noRace section">
        <h3>近4天暂无比赛</h3>

        <router-link
          v-if="isShowMore"
          class="more"
          to="/winterGame/moreSchedule"
          >查看全部赛程></router-link
        >
      </section>
    </template>
    <template v-if="isOut">
      <router-link class="view-all-games" :to="`/winterGame/moreSchedule`">
        <div class="view-all-games-content">
          <span class="view-text">查看全部赛程</span>
          <span class="view-arrow"></span>
        </div>
      </router-link>
    </template>
  </emptyModule>
</div>
</template>

<script>
import emptyModule from "./emptyModule.vue";
import pentagon from "./pentagon.vue";
import { timeFormatMonthDay } from "@/util/util.js";
import Btn from "@views/WinterGame/components/btn.vue";
import {
  queryseasonteamfrontconfig,
} from "../../../api/winterGame";
import { Toast } from "vant";
export default {
name: "schedule",
components: {
  emptyModule,
  pentagon,
  Btn,
},
props: {
  title: {
    type: String,
    default: "进行中",
  },
  padTeamId: {
    type: String,
    default: "",
  },
  scheduleData: {
    type: Object,
    default: null,
  },
  isShowMore: {
    type: Boolean,
    default: false,
  },
  gameType: {
    type: Number,
    default: 0,
  },
  isMoreSchedule: {
    type: Boolean,
    default: false,
  },
  isOut: {
    type: Boolean,
    default: false,
  },
  newSeason: {
    type: Boolean,
    default: true,
  },
  drawStatus: {
    type: Number,
    default: 0,
  },
  drawEndTime: {
    type: String,
    default: '',
  },
  agentGroupTeamBy: {
    type: Object,
    default: () => {},
  },
  isDrawed: {
    type: Boolean,
    default: false,
  },
  drawDate: {
    type: String,
    default: '',
  },
  seasonId: {
    type: String,
    default: '',
  },
},

computed: {
  formattedDate() {
    if (!this.scheduleData.section_start_date) return '';
    const date = new Date(this.scheduleData.section_start_date);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日`;
  },
  winStatusClass() {
    return "winStatus_" + this.scheduleData.status_a;
  },
  // 热门游戏类型数组（大乱斗、精英争霸赛、竞技场大乱斗、热身赛、竞技场争霸赛）
  hotGameTypes() {
    return [1, 2, 6, 8, 9];
  },
  // 竞技场类型数组（竞技场大乱斗、竞技场争霸赛）
  arenaGameTypes() {
    return [6, 9];
  },
  // 全国大赛类型数组（全国大赛）
  nationalGameTypes() {
    return [3, 4];
  },
  // 精英争霸赛类型
  eliteGameType() {
    return 2;
  },
  isCanDrawType() {
    return [2,3,4,9].includes(this.gameType);
  },
  // 判断是否为热门游戏类型
  isHotGameType() {
    return this.hotGameTypes.includes(this.gameType);
  },
  // 判断是否为竞技场类型
  isArenaGameType() {
    return this.arenaGameTypes.includes(this.gameType);
  },
  // 判断是否为全国大赛类型
  isNationalGameType() {
    return this.nationalGameTypes.includes(this.gameType);
  },
  // 判断是否为精英争霸赛
  isEliteGameType() {
    return this.gameType === this.eliteGameType;
  },
  // 判断热门游戏是否已开始
  isHotGameStarted() {
    return this.isHotGameType && 
           new Date(this.scheduleData.real_section_start_date).getTime() <= new Date().getTime();
  },
  // 是否显示数据
  shouldShowData() {
    return this.isHotGameStarted;
  },
  // 是否显示下个比赛日
  shouldShowNextGameDate() {
    return this.isHotGameType && 
           new Date(this.scheduleData.real_section_start_date).getTime() > new Date().getTime();
  },
  // 是否显示标准比赛模板
  shouldShowStandardGame() {
    return (this.isNationalGameType || this.gameType === 5 || this.gameType === 7);
  },
  // 判断当前日期是否等于drawDate
  isCurrentDrawDate() {
    if (!this.drawDate) return false;
    if (this.drawStatus == 3) {
      return false
    } else {
      const today = new Date();
      const drawDate = new Date(this.drawDate);
      
      // 格式化为 yyyy-mm-dd 进行比较
      const todayStr = today.toISOString().split('T')[0];
      const drawDateStr = drawDate.toISOString().split('T')[0];
      
      return todayStr === drawDateStr;
    }
  },
},
data() {
  return {
    winStatus: 1,
    scheduleStatus: 2,
    partitionSkipUrl: '',
  };
},
methods: {
  async queryseasonteamfrontconfig() {
    const homeConfig = JSON.parse(sessionStorage.getItem('homeConfig'));
    if (homeConfig) {
      const { seasonTagId } = homeConfig;
      if (seasonTagId) {
        let params = {
          param: {
            seasonTagId: seasonTagId,
          },
        };
        let res = await queryseasonteamfrontconfig(params);
        if (res.code == 0) {
          if (res.data) {
            const { partitionSkipUrl } = res.data;
            this.partitionSkipUrl = partitionSkipUrl;
          }
        } else {
          Toast(res.message);
        }
      }
    }
  },
  timeFormatMonthDay(date) {
    return timeFormatMonthDay(date);
  },
  goDrawLots() {
    this.$emit("toDrawLots");
  },
  // 查看区分情况
  toDrawResult() {
    if (this.partitionSkipUrl) {
      window.location.href = this.partitionSkipUrl;
      return;
    }
  },
},
mounted() {
  // console.log(this.scheduleData);
  this.queryseasonteamfrontconfig();
},
filters: {
  formatNumberFilter(value) {
    return value || 0;
  },
  formatDateToMonthDay(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const month = date.getMonth() + 1; // getMonth() returns 0-11
    const day = date.getDate();
    return `${month}月${day}日`;
  }
},
};
</script>

<style lang="less" scoped>
.view-all-games {
  padding: 58px;
  width: 100%;
  // display: block;
  // font-size: 24px;
  // font-family: PingFangSC-Medium, PingFang SC;
  // font-weight: 500;
  // color: #58abf6;
  // text-align: center;
  // padding-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  .view-all-games-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .view-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 40px;
      color: #323232;
      line-height: 56px;
      text-align: justify;
      font-style: normal;
    }
    .view-arrow {
      width: 40px;
      height: 40px;
      margin-left: 10px;
      background: #58ABF6;
      border-radius: 50%;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      &::after {
        content: '';
        width: 12px;
        height: 12px;
        border:  #fff solid;
        border-width: 3px 3px 0 0;
        transform: rotate(45deg);
      }
    }
  }
}
.schedule {
position: relative;
div.bar {
  position: absolute;
  top: 8px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  span {
    display: inline-block;

    width: 16px;
    height: 14px;
    background: linear-gradient(180deg, #4099f8 0%, #1650b1 100%);

    &:first-child {
      margin-left: -16px;
      border-top-left-radius: 7px;
      border-bottom-left-radius: 7px;
    }

    &:last-child {
      margin-right: -16px;
      border-top-right-radius: 7px;
      border-bottom-right-radius: 7px;
    }
  }
}
.look-more-link {
  margin: 24px 24px 0 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 28px;
  color: #58ABF6;
  line-height: 40px;
  text-align: right;
  font-style: normal;
}
.war-zone-name {
  border-bottom:  2px solid rgba(88,171,246,0.2);
  padding: 40px 0 32px;
  margin: 0 32px;
  .war-zone-name-text {
    margin: 0;
    padding: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 56px;
    color: #58ABF6;
    line-height: 80px;
    text-align: center;
    font-style: normal;
  }
  &.group_name {
    margin: 0 32px 24px;
  }
}
.game-type-title {
  height: 1em;
  line-height: 1em;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #323232;
  > img:first-child {
    display: block;
    width: 32px;
    height: 24px;
    margin-right: 10px;
  }
  > img:last-child {
    display: block;
    width: 32px;
    height: 24px;
    margin-left: 10px;
  }
  &.game-type-title-draw {
    font-size: 1.5rem;
  }
}
.header {
  margin-top: 24px;
  height: 60px;
  background: #e4f1fd;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-right: 24px;
  > div {
    position: relative;
    left: 56px;
  }

  h3 {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    line-height: 44px;
    // position: absolute;
    // left: 0;
    text-align: end;
    // right: 0;
    margin-left: 28px;
  }
  .more {
    width: 112px;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #58abf6;
    line-height: 34px;
    position: relative;
    z-index: 10;
  }
}
.header2 {
  position: relative;
  margin-top: 24px;
  height: 60px;
  background: #e4f1fd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #323232;

  padding-right: 24px;
  .next-game-date {
    position: absolute;
    width: 200px;
    height: 40px;
    left: 20px;
    top: 10px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #323232;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    &.hot-game-item {
      left: 210px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #323232;
      line-height: 44px;
      text-align: center;
      font-style: normal;
    }
  }
  h3 {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #323232;
    line-height: 44px;
    // position: absolute;
    // left: 0;
    text-align: end;
    // right: 0;
    margin-left: 28px;
  }
  .more {
    width: 112px;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #58abf6;
    line-height: 34px;
    position: relative;
    z-index: 10;
  }
}
.section2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > div {
    width: 85%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // flex-direction: column;
    position: relative;
    .wapper2 {
      width: auto !important;
      .topIcon{
        position: absolute;
        width: 124px;
        bottom: 16px;
        right: -115px;
        img {
          width: 100%;
        }
      }
    }
    .wapper {
      width: 50%;
      .data-num {
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
        margin: 16px 0;
        padding: 0;
        position: relative;
        display: flex;
        justify-content: center;
        .status {
          width: 148px;
          height: 38px;
          background: #dcdcdd;
          border-radius: 20px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #f6f9fd;
          line-height: 40px;
          position: absolute;
          text-align: center;
          right: -165px;
          top: 34px;
          transform: translateY(-50%);
        }
      }
      .describe {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        margin: 0 0 32px 0;
        padding: 0;
        display: flex;
        justify-content: center;
        &.no-rank {
          padding-top: 10px;
        }
      }
    }
  }
  > div:first-child::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 65%;
    height: 1px;
    background-color: #dee5f0;
    // border-bottom: 1px solid #dee5f0;
  }
}
.section-hot-game {
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    width: 85%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    .wapper2 {
      width: auto !important;
      .topIcon{
        position: absolute;
        width: 124px;
        bottom: 16px;
        right: -115px;
        img {
          width: 100%;
        }
      }
    }
    .wapper {
      width: 50%;
      .data-num {
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #323232;
        margin: 16px 0;
        padding: 0;
        position: relative;
        display: flex;
        justify-content: center;
        .status {
          width: 148px;
          height: 38px;
          background: #dcdcdd;
          border-radius: 20px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #f6f9fd;
          line-height: 40px;
          position: absolute;
          text-align: center;
          right: -165px;
          top: 34px;
          transform: translateY(-50%);
        }
      }
      .describe {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #68707d;
        margin: 0 0 32px 0;
        padding: 0;
        display: flex;
        justify-content: center;
        &.no-rank {
          padding-top: 50px;
        }
      }
    }
  }
}
.section3{
  .only-section-name {
    height: 130px;
    line-height: 130px;
  }
  >div {
    text-align: center;
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #323232;
  }
}
.section {
  overflow: hidden;
  margin-top: 40px;
  padding: 0px 48px 10px;

  &.noRace {
    text-align: right;
    h3 {
      height: 66px;
      font-size: 48px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      text-align: center;
      line-height: 66px;
      margin: 56px 0 18px 0;
    }
    a {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #58abf6;
      line-height: 40px;
    }
  }

  &.rowReverse {
    div {
      flex-direction: row-reverse;
    }
  }
  .notional-game-type {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 238px;
      // padding: 0 24px;
      height: 46px;
      background: rgba(88, 171, 246, 0.16);
      border-radius: 24px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #619cf5;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .group_name {

  }

  .summer-jb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      img {
        width: 32px;
        height: 32px;
        margin-right: 15px;
      }
    }
  }
  .vs-member {
    line-height: 56px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #323232;

    span {
      flex-shrink: 0;
      width: 64px;
      height: 64px;
      background: #58abf6;
      border-radius: 50%;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
      margin: 0 48px;
      font-weight: 600;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
    label {
      // 4倍字体大小，某些设备会四舍五入
      width: 4.5em;
      height: 102px;
      font-size: 32px;
      padding: 0;
      margin: 20px 0 0;
      text-align: center;
      word-wrap: break-word;
    }
    h3 {
      width: 4em;
      height: 102px;
      font-size: 40px;
      padding: 0;
      margin: 20px 0 0;
      text-align: center;
      word-wrap: break-word; /* 或者使用 overflow-wrap: break-word; */
      font-weight: 600;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
    }
  }
  .spring-jb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      img {
        width: 32px;
        height: 32px;
        margin-right: 4px;
      }
    }
  }
}
section.winStatus_4 {
  background: url("../../../assets/images/winterGame/winStatus_0.png")
    no-repeat;
  background-size: cover;
}
section.winStatus_1 {
  background: url("../../../assets/images/winterGame/winStatus_1.png")
    no-repeat;
  background-size: cover;
}
section.winStatus_2 {
  background: url("../../../assets/images/winterGame/winStatus_2.png")
    no-repeat;
  background-size: cover;
}
.draw-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  .draw-wrap-content {
    width: 100%;
    margin-top: 24px;
    background: #E4F1FD;
  }
  .draw-title {
    padding-top: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 56px;
    color: #323232;
    text-align: center;
    font-style: normal;
    &.draw-result {
      color: #58ABF6;
    }
    &.draw-result-no-name {
      padding-bottom: 24px;
    }
  }
  .draw-info {
    margin-top: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #323232;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 24px;
  }
  .draw-end-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #58ABF6;
    line-height: 40px;
    text-align: right;
    font-style: normal;
  }
  .draw-time {
    margin-top: 16px;
    padding-bottom: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #323232;
    line-height: 40px;
    text-align: center;
    font-style: normal;
  }
  .draw-btn {
    width: 312px;
    height: 64px;
    margin-top: 48px;
    background: #58ABF6;
    border-radius: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 64px;
    text-align: center;
    font-style: normal;
    cursor: pointer;
  }
}
}
</style>
